import React from "react";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import useGetActiveAtClosedLocation from "./hooks/useGetActiveAtClosedLocation";
import { CSVLink } from "react-csv";
import { UsersIcon } from "@heroicons/react/24/solid";
import { useRecoilState, useRecoilValue } from "recoil";
import { mainSelectedTab } from "../../atoms";
import { useHistory } from "react-router-dom";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { employeeFromReports } from "../../Employees/Confie/atoms/atoms";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import { EmployeeTabs } from "../../../EmployeeTab/EmployeeTab";
import DownloadButton from "../../../../components/DownloadButton";
import { accountAtom } from "../../../Login/atoms/AccountAtom";

interface IActiveEmployeesAtClosedLocation {
  employeenumber: string;
  fullname: string;
  reportsToFullname: string;
  status: string;
  officeName: string;
  officeStatus: string;
  state: string;
}
export const ActiveEmployeesAtClosedLocation = () => {
  const { data: employeesClosedLocation, isLoading: closedLocationLoading } =
    useGetActiveAtClosedLocation();

  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);
  const [, setShowFromReports] = useRecoilState(employeeFromReports);
  const user = useRecoilValue(accountAtom);

  const exportdata = employeesClosedLocation
    ?.filter((x) =>
      user.isFranchise && user.isNonFranchise
        ? x.employeeTypeName !== ""
        : user.isFranchise
        ? x.employeeTypeName?.toLowerCase() === "franchise"
        : x.employeeTypeName?.toLowerCase() !== "franchise"
    )
    ?.map((emp: IActiveEmployeesAtClosedLocation) => {
      return {
        "Employee ID": '=""' + emp.employeenumber + '""',
        "Full Name": emp.fullname,
        "Reports To": emp.reportsToFullname,
        Status: emp.status,
        "Office Name": emp.officeName,
        "Office Status": emp.officeStatus,
        State: emp.state,
      };
    });
  let dateTimeToday = new Date(new Date().toLocaleString()).toLocaleString();
  const csvReport = {
    filename: "ActiveEmployeesAtClosedLocation_" + dateTimeToday + ".csv",
    data: exportdata ? exportdata : [],
  };
  const employeeColumns = [
    { title: "Employee ID", field: "employeenumber" },
    {
      title: "Full Name",
      field: "fullname",
      render: (rowData) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              const url = "/employeetab/employee";
              history.push({
                pathname: url,
                state: {
                  employeeNumber: rowData?.employeeid,
                  action: "EmployeeClosedLocationReports",
                },
              });
              window.location.reload();
              let userTabs = [
                {
                  to: "",
                },
              ];
              [...EmployeeTabs].forEach((tabs) => {
                let temp = [...userPermissions].filter(
                  (user) => user === tabs.permission
                );
                if (temp.length > 0)
                  userTabs.push({
                    to: tabs.to,
                  });
              });
              userTabs.shift();
              const index = userTabs.findIndex((c) => c.to === url);
              setSelectedIndex(index);
              setShowFromReports(true);
            }}
          >
            <span className="text-quinary  font-bold underline text-sm ">
              {rowData.fullname}
            </span>
          </div>
        );
      },
    },
    { title: "Reports To", field: "reportsToFullname" },
    { title: "Status", field: "status" },
    {
      title: "Office Name",
      field: "officeName",
      render: (rowData) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              const url = "/officesettings/officesetting";
              history.push({
                pathname: url,
                state: {
                  officeCode: rowData?.officecode,
                  action: "ClosedLocation",
                },
              });
              window.location.reload();
              let userTabs = [
                {
                  to: "",
                },
              ];
              [...OfficeTabs].forEach((tabs) => {
                let temp = [...userPermissions].filter(
                  (user) => user === tabs.permission
                );
                if (temp.length > 0)
                  userTabs.push({
                    to: tabs.to,
                  });
              });
              userTabs.shift();
              const index = userTabs.findIndex((c) => c.to === url);
              setSelectedIndex(index);
            }}
          >
            <span className="text-quinary  font-bold underline text-sm ">
              {rowData.officeName}
            </span>
          </div>
        );
      },
    },
    { title: "Office Status", field: "officeStatus" },
    { title: "State", field: "state" },
  ];

  return (
    <div className="text-xs items-center">
      <div className="">
        <div className="mx-4 mt-4 overflow-x-auto">
          <div className="flex mb-2 gap-2 items-center">
            <div>
              <UsersIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
            </div>
            <div className="flex flex-col leading tight">
              <div className="text-gray-500 text-md font-medium">
                Report: Employees & Offices
              </div>
              <div className="flex items-center font-bold text-lg text-primary">
                Active Employees at Closed Locations
              </div>
            </div>
          </div>
          <div className="mt-2" />
          <div className="flex justify-between mb-2 mr-2">
            <div className="flex items-center gap-1">
              <span className="text-gray-500 text-sm">Total Records: </span>
              <span className="text-primary text-base font-semibold">
                {user.isFranchise && user.isNonFranchise
                  ? employeesClosedLocation?.length
                  : employeesClosedLocation?.filter(
                      (x) =>
                        x.employeenumber !== "" &&
                        (user.isFranchise
                          ? x.employeeTypeName?.toLowerCase() === "franchise"
                          : x.employeeTypeName?.toLowerCase() !== "franchise")
                    )?.length}
              </span>
            </div>

            <CSVLink {...csvReport}>
              <DownloadButton
                buttonValue="Download File"
                onClick={() => exportdata}
                className={undefined}
                disabled={undefined}
              />
            </CSVLink>
          </div>
        </div>
        <div className="box-shadow mx-4 mb-4 mt-2 overflow-x-auto grid grid-row">
          <MaterialTableTS
            data={
              user.isFranchise && user.isNonFranchise
                ? employeesClosedLocation
                : employeesClosedLocation?.filter(
                    (x) =>
                      x.employeenumber !== "" &&
                      (user.isFranchise
                        ? x.employeeTypeName?.toLowerCase() === "franchise"
                        : x.employeeTypeName?.toLowerCase() !== "franchise")
                  )
            }
            isLoading={closedLocationLoading}
            columns={employeeColumns}
            showTitle={false}
          />
        </div>
      </div>
    </div>
  );
};
